/**
 * RiseBanner.jsx · v101.147.0 / v101.159.0
 * Identidad del AMBIENTE DE PRUEBAS RISE (backend con AFC_ENTORNO=rise). En producción no muestra ni cambia nada.
 * v101.159.0 · En RISE, en TODAS las pantallas (incluido el login): franja VERDE fija «RISE · AMBIENTE DE PRUEBAS»,
 *              barra superior verde con la marca RISE, pestaña del navegador «RISE · …» e ícono verde «R».
 */
import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import api from "../lib/api";

export const RISE_GREEN = "#15803D";
export const RISE_GREEN_DARK = "#052E16";
export const RISE_BAR_H = 24;   // alto de la franja (px)

let _cache = null;          // una sola consulta por carga de la web
let _pending = null;

export function useEntorno() {
  const [env, setEnv] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    _pending = _pending || api.get("/v1/entorno")
      .then(({ data }) => (_cache = data || { rise: false }))
      .catch(() => (_cache = { rise: false }));
    _pending.then(setEnv);
  }, []);
  return env;
}

const FAVICON = "data:image/svg+xml," + encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="14" fill="${RISE_GREEN}"/>` +
  `<text x="32" y="45" font-family="Arial,Helvetica,sans-serif" font-size="40" font-weight="700" fill="#fff" text-anchor="middle">R</text></svg>`);

function _prefixTitle() {
  const t = document.title || "";
  if (!t.startsWith("RISE · ")) document.title = `RISE · ${t.replace(/^\[RISE\]\s*/, "")}`;
}

/** Montar UNA vez en la raíz (App.js): aplica la identidad RISE en toda la web. */
export default function RiseBanner() {
  const env = useEntorno();
  useEffect(() => {
    if (!env?.rise) return undefined;
    const root = document.documentElement;
    root.classList.add("afc-rise");
    root.style.setProperty("--rise-bar-h", `${RISE_BAR_H}px`);
    // Pestaña del navegador: siempre «RISE · …» (las pantallas cambian el título)
    _prefixTitle();
    const titleEl = document.querySelector("title");
    const obs = titleEl ? new MutationObserver(_prefixTitle) : null;
    if (obs) obs.observe(titleEl, { childList: true, characterData: true, subtree: true });
    // Ícono verde «R»
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = FAVICON;
    return () => { if (obs) obs.disconnect(); };
  }, [env]);
  if (!env?.rise) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[5000] text-center text-[11px] font-bold tracking-wide px-3 flex items-center justify-center gap-2 overflow-hidden whitespace-nowrap"
      style={{ background: RISE_GREEN, color: "#fff", height: RISE_BAR_H }} data-testid="rise-banner">
      <FlaskConical size={13} />
      <span className="px-1.5 rounded bg-white text-[10px] font-black" style={{ color: RISE_GREEN }}>RISE</span>
      AMBIENTE DE PRUEBAS · datos de prueba, no es producción
      <a href="/integraciones/ambiente-rise" className="underline hidden sm:inline">Integraciones RISE</a>
    </div>
  );
}

/** Marca RISE para barras / encabezados (no renderiza nada en producción). */
export function RiseTag({ className = "" }) {
  const env = useEntorno();
  if (!env?.rise) return null;
  return (
    <span className={`px-2 py-0.5 rounded text-[10px] font-black tracking-widest ${className}`}
      style={{ background: "#fff", color: RISE_GREEN }} data-testid="rise-tag">RISE</span>
  );
}
